module.exports = __webpack_public_path__ + "static/media/house9lg.c0007699.png";